import React from 'react'
import { RouteRedirect } from '../../components/RouteRedirect'
import * as Pages from '../../pages'
import { NewRouteDefinition } from '../../routes'
import { ConsoleContext } from '../Console'
import { Console } from '../Console/Console'

export const getAppRoutes: () => NewRouteDefinition = () => ({
  path: '/',
  element: <RouteRedirect routePath="/console" />,
  usage: 'simple',
  routes: [
    {
      path: 'login',
      element: <Pages.Login />,
      usage: 'simple',
    },
    {
      path: 'forgot-password',
      element: <Pages.ForgotPassword />,
      usage: 'simple',
    },
    {
      path: 'console/*',
      element: (
        <ConsoleContext>
          <Console />
        </ConsoleContext>
      ),
      usage: 'simple',
      requiredAuth: true,
    },
  ],
})
